export default __webpack_public_path__ + "images/tz-2218434d34c055a29fdf4ebd154fe074.svg";